import * as z from "zod";

export const startAcumaticaConnect = {
  name: "startAcumaticaConnect" as const,
  input: z.object({
    instanceUrl: z.string().min(1),
    clientId: z.string().min(1),
    clientSecret: z.string().min(1),
    endpointVersion: z.string().min(1).optional(),
  }),
  /** Consent page to open in a popup; the callback completes the connection. */
  output: z.object({ authorizationUrl: z.string() }),
};
